// extracted by mini-css-extract-plugin
export default {"TwoDimsFeature":"wu_a bii_b bii_we"};